import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

export function Empty({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="empty" className={cn("flex min-w-0 flex-col items-center justify-center gap-6 rounded-lg border-dashed p-6 text-center text-muted-foreground", className)} {...props} />;
}

export function EmptyHeader({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="empty-header" className={cn("flex max-w-sm flex-col items-center gap-2", className)} {...props} />;
}

export function EmptyTitle({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="empty-title" className={cn("text-sm font-medium text-foreground", className)} {...props} />;
}

export function EmptyDescription({ className, ...props }: ComponentProps<"p">) {
  return <p data-slot="empty-description" className={cn("m-0 text-xs text-muted-foreground", className)} {...props} />;
}
